import {FC} from 'react'
import {ColumnInstance} from 'react-table'

import WABAAccount from "../../../../../../models/WABAccount"
import { Table } from '../../../../../../../types'

type Props = {
  column: ColumnInstance<WABAAccount & Table>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {CustomHeaderColumn}